import type { SVGProps } from 'react'

interface OzoneIconProps extends SVGProps<SVGSVGElement> {}

export function OzoneIcon(props: OzoneIconProps) {
  return (
    <svg
      viewBox="0 0 31 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_1136_2121)">
        <path
          d="M10.9236 25.2578C10.9326 24.7131 10.4687 24.2673 9.92393 24.2673H5.37118C4.56906 25.6823 4.05448 27.2817 3.90778 28.9862C3.86101 29.5297 4.29096 29.9964 4.83643 29.9964H7.61218V28.5528C7.61218 27.2639 8.66081 26.2153 9.94972 26.2153C10.4812 26.2153 10.9147 25.7873 10.9236 25.2578Z"
          fill="currentColor"
        />
        <path
          d="M23.5261 21.5729C23.4872 21.5777 23.4477 21.581 23.4074 21.581H19.0791C17.4886 21.647 17.4899 23.9127 19.0791 23.9781H25.4594C24.9229 23.0922 24.2717 22.2835 23.5261 21.5729Z"
          fill="currentColor"
        />
        <path
          d="M26.3862 25.8853H19.0783C14.9314 25.6959 14.9684 19.8344 19.1254 19.6738H20.8711C16.265 17.1529 9.99334 18.4176 6.7207 22.36H9.90144C13.7578 22.5092 13.7993 27.9388 9.95483 28.1225C9.71495 28.123 9.51884 28.313 9.51884 28.5528V29.9964H26.1624C26.707 29.9964 27.1378 29.5309 27.0911 28.9883C26.9979 27.9047 26.7559 26.8637 26.3862 25.8853Z"
          fill="currentColor"
        />
        <path
          d="M1.37913 28.2051C0.893614 28.2051 0.5 28.5988 0.5 29.0843V29.1136C0.546476 30.28 2.21224 30.2791 2.25825 29.1136V29.0843C2.25825 28.5988 1.86464 28.2051 1.37913 28.2051Z"
          fill="currentColor"
        />
        <path
          d="M15.4996 14.1135L15.4622 14.1136C14.2972 14.1626 14.3002 15.8261 15.4643 15.8718H15.4665L15.4995 15.8718H15.5219H15.5249C16.6893 15.8255 16.6915 14.1633 15.5279 14.1135H15.4996Z"
          fill="currentColor"
        />
        <path
          d="M11.8104 16.3586C11.8863 16.3586 11.9634 16.3487 12.0402 16.328L12.0958 16.3131C12.565 16.1881 12.844 15.7064 12.719 15.2373C12.594 14.7681 12.1124 14.4892 11.6432 14.6141L11.5817 14.6306C11.1129 14.7572 10.8356 15.2399 10.9623 15.7086C11.0681 16.1006 11.4229 16.3586 11.8104 16.3586Z"
          fill="currentColor"
        />
        <path
          d="M18.2699 15.2355C18.1453 15.7048 18.4248 16.1862 18.894 16.3107L18.9502 16.3257C19.4065 16.4521 19.903 16.1773 20.0272 15.7045C20.153 15.2356 19.8749 14.7534 19.4059 14.6275L19.345 14.6113C18.8759 14.4867 18.3945 14.7663 18.2699 15.2355Z"
          fill="currentColor"
        />
        <path
          d="M8.0238 16.1069L7.96871 16.1388C7.54895 16.3828 7.40648 16.9209 7.65046 17.3406C7.89586 17.7643 8.43986 17.9006 8.85229 17.6589L8.90181 17.6302C9.3225 17.3878 9.46697 16.8502 9.22451 16.4296C8.98205 16.0091 8.44443 15.8645 8.0238 16.1069Z"
          fill="currentColor"
        />
        <path
          d="M22.0912 17.6258L22.1409 17.6545C22.5534 17.8959 23.0974 17.759 23.3424 17.3351C23.586 16.9152 23.4431 16.3772 23.0231 16.1336L22.9676 16.1016C21.9332 15.5604 21.1036 17.005 22.0912 17.6258Z"
          fill="currentColor"
        />
        <path
          d="M26.1212 19.767C26.4648 19.424 26.4654 18.8673 26.1224 18.5237L26.0776 18.479C25.7337 18.1364 25.177 18.1375 24.8344 18.4815C24.4917 18.8255 24.4929 19.3821 24.8369 19.7248L24.8779 19.7657C25.2209 20.1094 25.7775 20.1099 26.1212 19.767Z"
          fill="currentColor"
        />
        <path
          d="M29.3753 26.3274C29.8444 26.2024 30.1234 25.7206 29.9984 25.2515L29.9819 25.1901C29.8553 24.7214 29.3727 24.444 28.9039 24.5707C28.4352 24.6973 28.1579 25.18 28.2846 25.6487L28.2995 25.7044C28.4228 26.1773 28.9188 26.4529 29.3753 26.3274Z"
          fill="currentColor"
        />
        <path
          d="M28.503 21.6316L28.471 21.5764C28.2267 21.1567 27.6884 21.0147 27.2689 21.2589C26.8494 21.5032 26.7073 22.0414 26.9516 22.461L26.9801 22.5103C27.2242 22.9348 27.7679 23.0728 28.1809 22.8324C28.6015 22.5898 28.7457 22.0521 28.503 21.6316Z"
          fill="currentColor"
        />
        <path
          d="M2.09218 24.5803C1.62337 24.4542 1.14103 24.732 1.0149 25.2009L0.998374 25.2626C0.873832 25.7319 1.15339 26.2133 1.62267 26.3378C2.07929 26.4628 2.57506 26.1866 2.69784 25.7135L2.71273 25.6576C2.83891 25.1887 2.56105 24.7064 2.09218 24.5803Z"
          fill="currentColor"
        />
        <path
          d="M4.04314 22.4681C4.28677 22.0481 4.14377 21.5101 3.72378 21.2665C3.30385 21.0229 2.76583 21.1659 2.52225 21.5859L2.49049 21.6409C2.2482 22.0616 2.39284 22.5991 2.81359 22.8414C3.22684 23.0815 3.77049 22.9428 4.01413 22.5182L4.04314 22.4681Z"
          fill="currentColor"
        />
        <path
          d="M4.91424 18.4862L4.86953 18.5309C4.5269 18.8749 4.52802 19.4316 4.87199 19.7742C5.21596 20.1168 5.77256 20.1157 6.11525 19.7717L6.15622 19.7307C6.94913 18.8738 5.7718 17.6955 4.91424 18.4862Z"
          fill="currentColor"
        />
        <path
          d="M29.6213 28.2051C29.1358 28.2051 28.7422 28.5988 28.7422 29.0843V29.1136C28.7887 30.28 30.4544 30.2791 30.5004 29.1136V29.0843C30.5004 28.5988 30.1068 28.2051 29.6213 28.2051Z"
          fill="currentColor"
        />
        <path
          d="M14.8613 9.62798C15.1515 9.89483 15.6754 9.96457 16.0349 9.63994L18.3032 7.64784C18.668 7.32749 18.704 6.772 18.3836 6.40722C18.0633 6.04238 17.5078 6.00639 17.1429 6.32675L16.3338 7.03732V0.882788C16.3338 0.397276 15.9402 0.00366211 15.4547 0.00366211C14.9692 0.00366211 14.5756 0.397276 14.5756 0.882788V6.98345L13.871 6.33876C13.5129 6.01097 12.9567 6.0357 12.629 6.39385C12.3012 6.75207 12.3259 7.30815 12.6841 7.63588L14.8613 9.62798Z"
          fill="currentColor"
        />
        <path
          d="M24.5293 13.5682C24.8186 13.8344 25.344 13.9051 25.7029 13.5802L27.9712 11.5881C28.817 10.7835 27.7171 9.53245 26.8109 10.267L26.0018 10.9776V4.82297C26.0018 4.33746 25.6082 3.94385 25.1227 3.94385C24.6372 3.94385 24.2436 4.33746 24.2436 4.82297V10.9236L23.539 10.2789C23.1808 9.95121 22.6246 9.97588 22.297 10.3341C21.9692 10.6923 21.9939 11.2484 22.3521 11.5761L24.5293 13.5682Z"
          fill="currentColor"
        />
        <path
          d="M5.19145 13.5682C5.48174 13.8349 6.00534 13.9049 6.36496 13.5801L8.63329 11.588C8.99812 11.2677 9.03411 10.7122 8.71376 10.3474C8.3934 9.98256 7.83791 9.94658 7.47313 10.2669L6.66404 10.9775V4.82297C6.66404 4.33746 6.27043 3.94385 5.78492 3.94385C5.29941 3.94385 4.90579 4.33746 4.90579 4.82297V10.9236L4.2012 10.2789C3.30942 9.52571 2.18542 10.7554 3.01432 11.5761L5.19145 13.5682Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1136_2121">
          <rect
            width="30"
            height="30"
            fill="currentColor"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
